// ── Zentrale Gebäude-Layout-Konstanten ─────────────────────────
// Eine einzige Quelle der Wahrheit für BuildingPlan.js und wind.js.
// Position_x / position_y sind in Prozent (0–100) relativ zum Plan-Container.
// ────────────────────────────────────────────────────────────────

// SVG viewBox (für BuildingPlan-Rendering)
export const SVG_W = 1000;
export const SVG_H = 720;

// Höhen-Konstanten im SVG (Pixel, viewBox-Koordinaten)
export const ANT_TOP = 30;
export const ANT_H = 80;
export const ROOF_H = 40;
export const BUILDING_TOP = ANT_TOP + ANT_H + ROOF_H;  // = 150
export const FLOOR_H = 58;
export const STREET_H = 30;

// Etagen von oben nach unten
export const FLOORS = ["DG", "6. OG", "5. OG", "4. OG", "3. OG", "2. OG", "1. OG", "EG"];

export const BUILDING_BODY_H = FLOORS.length * FLOOR_H;  // 8 * 58 = 464
export const TOTAL_H = BUILDING_TOP + BUILDING_BODY_H + STREET_H;  // 150 + 464 + 30 = 644

// Container-Höhe in CSS (px) – das ist was die User sehen, position_y bezieht sich darauf
export const CONTAINER_H = 644;

// Breiten-Konstanten (Pixel, viewBox)
export const PAD_X = 20;
export const DIV_W = 4;
export const BUILDING_W = SVG_W - 2 * PAD_X;
export const UNIT_W = (BUILDING_W - 2 * DIV_W) / 3;

// Häuser (links nach rechts in Prozent der Plan-Breite)
export const HOUSE_NUMS = ["52", "50", "48"];

// X-Grenzen der drei Häuser in Prozent (auf Basis der SVG-Breite)
// Haus 52 liegt zwischen 0–33%, Haus 50 zwischen 33–66%, Haus 48 zwischen 66–100% – aber präzise:
// Linke Kante Haus 52: PAD_X / SVG_W = 2.0%
// Übergang 52→50: (PAD_X + UNIT_W + DIV_W/2) / SVG_W
// Übergang 50→48: (PAD_X + 2*UNIT_W + 3*DIV_W/2) / SVG_W
// Rechte Kante Haus 48: (PAD_X + BUILDING_W) / SVG_W = 98.0%
export const HOUSE_BOUNDARIES_PCT = [
  ((PAD_X + UNIT_W + DIV_W / 2) / SVG_W) * 100,           // ~34.07
  ((PAD_X + 2 * UNIT_W + 3 * DIV_W / 2) / SVG_W) * 100,   // ~67.27
];

/**
 * Liefert Hausnummer aus position_x (Prozent 0–100).
 */
export function houseFromX(x) {
  if (x === null || x === undefined) return null;
  if (x < HOUSE_BOUNDARIES_PCT[0]) return "Nr. 52";
  if (x < HOUSE_BOUNDARIES_PCT[1]) return "Nr. 50";
  return "Nr. 48";
}

/**
 * Liefert Etagen-Label aus position_y (Prozent 0–100).
 * Container-Höhe ist CONTAINER_H px. position_y=0 ist oben (Antenne),
 * position_y=100 ist unten (Strasse).
 */
export function floorFromY(y) {
  if (y === null || y === undefined) return null;
  const yPx = (y / 100) * CONTAINER_H;

  // Oberhalb Gebäude-Körper = Dach-Bereich (Antenne)
  if (yPx < BUILDING_TOP) return "Dach";

  // Innerhalb Gebäude
  const floorIdx = Math.floor((yPx - BUILDING_TOP) / FLOOR_H);
  if (floorIdx >= 0 && floorIdx < FLOORS.length) {
    return FLOORS[floorIdx];
  }

  // Unterhalb Gebäude = Strasse
  return null;
}
